import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7acb73exdq: FaireBrandEntity = {
  token: "b_7acb73exdq",
  type: "brand",
  name: "Pierced Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/00ffb00c381d665af484cb2b46d9d2727f0ec39f0ba0afcb9eb38a9172db64c1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb96b3e980a14c6908838095103562c07bffc89b0f6f0cca11bb6bc3ba699a1a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/00ffb00c381d665af484cb2b46d9d2727f0ec39f0ba0afcb9eb38a9172db64c1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb96b3e980a14c6908838095103562c07bffc89b0f6f0cca11bb6bc3ba699a1a.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Pierced Co — where sensitive ears meet everyday comfort. We’re a mother-daughter duo, Brit and Wren, on a mission to make earrings that all ages can live in. Think: playdates, dance recitals, sleepovers, and beach days — all without ever taking them off.\n\nIt all began when Wren expressed her desire to get her ears pierced. As someone with extremely sensitive ears, I hadn't worn earrings for years and was concerned she might face the same issues: finding cute, affordable earrings that wouldn’t irritate her ears. Tired of red, itchy lobes and broken promises from “hypoallergenic” brands, we decided to create our own. \n\nWhat Makes Us Different?\n-Medical-Grade Materials: Our earrings are crafted from implant-grade stainless steel, ensuring they're nickel-free, lead-free, and copper-free so they can be worn 24/7 without worry.\n-Flat Screw-Backs & Flower Grips: No more poking posts or lost backs. Our signature flower backs (patent pending) are easy to grip and super secure.\n-Waterproof & Tarnish-Free: Swim, shower, and sweat without a second thought. These earrings are built to last.\n\nWe offer curated gift sets, interchangeable charms, and jewelry boxes — all designed to make accessorizing fun and fuss-free. We're thrilled to share our passion with you and hope our earrings bring a touch of joy and comfort to your store.\n \nXO,\nBrit + Wren",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.652Z",
    importedBy: "entity-db-cli",
  },
};
